// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"f2862ede","36":"5db99f09","67":"182b17c5","118":"ec9b3cf0","337":"d6f0d1c0","495":"9a774d92","604":"2ce394d5","621":"3fd71587","714":"c55a0e19","731":"a810465f","794":"9cece44b"}[chunkId] + ".chunk.css";
};